export default "__VITE_ASSET__CKUYsDFb__"